module.exports = __webpack_public_path__ + "static/7-da07824cdc9bbddc24f587293bad2632.png";